import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { AppConstants } from '../core/app.constants';
import { AuthAccessProvider } from '../core/core.auth';
import { AbsenceCause, AbsenceRequest, BaseComponent, DateUserAbsence, DateUserAbsenceResponse, User, UserContext, UserInfo } from '../core/core.component';
import { HolidaysReportComponent } from '../holidays-report/holidays-report.component';
import { AssenzeService } from '../service/assenze.service';
import { BusyProvider } from '../service/busy.service';
import { MessageProvider } from '../service/message.service';
import { UserService } from '../service/user.service';

declare var $: any;

@Component({
    selector: 'app-assenze',
    templateUrl: './assenze.component.html',
    styleUrls: ['./assenze.component.css'],
    host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class AssenzeComponent extends BaseComponent implements OnInit {
    it: any = AppConstants.ITA_CALENDAR_CONF;
    static DIALOG_ID: string = "detailAssenzaDialog";
    static DIALOG_MALATTIA_ID: string = "detailAssenzeMalattiaDialog";
    static DIALOG_OVERLAPPING_ID: string = "detailAssenzeOverlappingDialog";
    static DEFAULT_SUBJECT = "Richiesta Ferie in Approvazione";
    title: string = "";
    userContext: UserContext;
    userInfo: UserInfo = new UserInfo();
    requestFromDate: Date = null;
    requestTypes: SelectItem[] = [];
    requestTypeSelected: string = null;
    displayRequests: string = "";
    displayAbsences: string = "active";
    displayReport: string = "";
    completed: boolean = true;
    showFilter: boolean = true;
    requests: AbsenceRequest[] = [];
    causes: AbsenceCause[] = [];
    causeItems: SelectItem[] = [];
    causeSelected: number = null;
    users: User[] = [];
    sortField: string = null;
    sortAsc: boolean = false;
    usersSelected: SelectItem[] = [];
    usersGroupFilter: boolean = false;
    usersGroupFilterDialog: boolean = false;
    managedUsers: SelectItem[] = [];
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    currentUserId: number;
    currentRequest: AbsenceRequest = null;
    showApproveConfirmPopup: boolean = false;
    showDeleteConfirmPopup: boolean = false;
    dateBegin: Date = null;
    dateEnd: Date = null;
    detailMode: string = null;

    selectedGruppo: number = 0;
    gruppiUsers: SelectItem[] = [];
    gruppi: SelectItem[] = [];
    utentiVisibili: SelectItem[] = [];
    filterUsernames: SelectItem[] = [];
    utentiVisibiliDialog: SelectItem[] = [];
    numgruppi: number = null;

    offset: number = null;
    typeSelected: string = null;
    types: SelectItem[] = [];
    enabledDayType: boolean = false;

    overlapAbsences: RowDateAbsence[] = [];
    totalOverlapping: number = 0;
    subject: string = null;
    message: string = null;
    showMailSection: boolean = false;
    overlapLoading: boolean = false;

    isRequestDialogOpen: boolean = false;
    isRequestOverlappingDialogOpen: boolean = false;

    months: SelectItem[] = [];
    monthSelected: number = 0;
    years: SelectItem[] = [];
    yearSelected: number = 0;

    @ViewChild('reportcomponent')
    private holidayReport: HolidaysReportComponent;

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private assenzeService: AssenzeService,
        private userService: UserService,
        private busyProvider: BusyProvider,
        private datePipe: DatePipe) {
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
        this.userContext = this.authAccess.getUserContext();
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();
        if (this.userContext == null) {
            this.authAccess.invalidate();
            
            
        } else {
            // dal primo gennaio dell'anno corrente
            this.requestTypeSelected = "D";
            this.requestTypes.push({ label: "Tutte", value: "" });
            this.requestTypes.push({ label: "Approvate", value: "A" });
            this.requestTypes.push({ label: "Da Approvare", value: "D" });

            this.types.push({ label: "Intera", value: "F" });
            this.types.push({ label: "Mezza (Mattina)", value: "M" });
            this.types.push({ label: "Mezza (Pomeriggio)", value: "P" });
            this.typeSelected = "F";

            const today = new Date();
            this.monthSelected = today.getMonth();
            this.months.push({ label: "Gennaio", value: 0 });
            this.months.push({ label: "Febbraio", value: 1 });
            this.months.push({ label: "Marzo", value: 2 });
            this.months.push({ label: "Aprile", value: 3 });
            this.months.push({ label: "Maggio", value: 4 });
            this.months.push({ label: "Giugno", value: 5 });
            this.months.push({ label: "Luglio", value: 6 });
            this.months.push({ label: "Agosto", value: 7 });
            this.months.push({ label: "Settembre", value: 8 });
            this.months.push({ label: "Ottobre", value: 9 });
            this.months.push({ label: "Novembre", value: 10 });
            this.months.push({ label: "Dicembre", value: 11 });

            this.yearSelected = today.getFullYear();
            this.years.push({ label: "" + this.yearSelected, value: this.yearSelected });
            this.years.push({ label: "" + (this.yearSelected + 1), value: (this.yearSelected + 1) });

            let obs: Observable<any>[] = [];
            obs.push(this.assenzeService.getAbsenceCauses(this.userContext.srmToken));
            obs.push(this.userService.currentUserInfo(this.userContext.srmToken));
            obs.push(this.userService.getUsers(this.userContext.srmToken, false, false));
            Observable.forkJoin(obs).subscribe(
                results => {

                    this.causes = results[0].absenceCauses;
                    this.userInfo = results[1];
                    this.users = results[2].users;

                    for (let i = 0; i < this.causes.length; ++i) {
                        let current = this.causes[i];
                        if (current.type == "F" || current.type == "P") {
                            let des = current.description;
                            if (des != null && des.length > 1) {
                                let startChar = des.charAt(0);
                                des = (startChar + "").toUpperCase() + des.substring(1);
                            }
                            current.description = des;
                            this.causeItems.push({ label: des, value: current.id });
                        }
                    }

                    for (var i = 0; i < this.users.length; ++i) {
                        var current: User = this.users[i];
                        var username = current.username.toLowerCase();
                        if (this.userInfo.admin || username == this.userContext.userId.toLowerCase() || this.userInfo.managedUsers.includes(username)) {
                            this.filterUsers.push({ label: current.fullname, value: current.id });
                            this.filterUsernames.push({ label: current.username, value: current.id });
                        }

                        this.gruppiUsers.push({ label: this.getGruppoUser(current), value: current.id });

                        if (username == this.userContext.userId.toLowerCase()) {
                            this.currentUserId = current.id;
                        }
                    }

                    this.gruppi = [];
                    this.numgruppi = 0;
                    this.gruppi.push({ label: "Tutti i gruppi", value: this.numgruppi });
                    for (const key in this.userInfo.managedUsersMap) {
                        this.numgruppi++;
                        this.gruppi.push({ label: key, value: this.numgruppi });
                    }
                    for (let i = 0; i < this.filterUsers.length; i++) {
                        this.usersSelected.push(this.filterUsers[i]);
                        if (this.userInfo.managedUsers.some(user => this.filterUsernames[i].label.toLowerCase().includes(user.toLowerCase()))) {
                            this.managedUsers.push(this.filterUsers[i]);
                        }
                    }

                    this.searchRequests(true, true);
                },
                error => {
                    this.handleError(error);
                }
            );
        }
    }

    changeDateStart() {
        if (!this.dateEnd) {
            this.dateEnd = new Date(this.dateBegin);
        }
        this.checkSingleDay();
    }

    checkSingleDay() {
        this.enabledDayType = this.datePipe.transform(this.dateBegin, "yyyyMMdd") == this.datePipe.transform(this.dateEnd, "yyyyMMdd");
        this.typeSelected = "F";
    }

    private searchRequests(switchFilter: boolean, cleanMessage: boolean) {
        if (cleanMessage) {
            this.messageProvider.clearAll();
        }
        this.completed = false;
        var userIds = null;
        if (this.utentiVisibili.length > 0) {
            userIds = '';
            for (let i = 0; i < this.utentiVisibili.length; ++i) {
                userIds += ',' + this.utentiVisibili[i].value;
            }
            userIds = userIds.substring(1);
        }
        this.assenzeService.getRequests(this.userContext.srmToken, userIds, this.requestTypeSelected, this.requestFromDate).subscribe(
            result => {
                this.requests = result.applications;
                this.completed = true;
                if (switchFilter && this.requests.length != 0) {
                    this.toggleFilter();
                }
                this.fillRequestData();
                this.sort("dateRequest", false);
            },
            error => {
                this.completed = true;
                this.handleError(error);
            }
        );
    }

    private fillRequestData() {
        for (let i = 0; i < this.requests.length; ++i) {
            let current: AbsenceRequest = this.requests[i];
            for (let j = 0; j < this.causes.length; ++j) {
                if (this.causes[j].id == current.causeId) {
                    current.causeDescription = this.causes[j].description;
                    break;
                }
            }
            for (let j = 0; j < this.users.length; ++j) {
                if (this.users[j].id == current.approverUserId) {
                    current.approverFullname = this.users[j].fullname;
                    break;
                }
            }
            for (let j = 0; j < this.users.length; ++j) {
                if (this.users[j].id == current.userId) {
                    current.username = this.users[j].username;
                    current.fullname = this.users[j].fullname;
                    break;
                }
            }
        }
    }

    filterUser(event) {
        this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
    }

    openRequestDetail(req: AbsenceRequest) {
        this.title = (req == null ? "Inserimento " : "Modifica ") + "Richiesta";
        this.dateBegin = req != null ? new Date(req.dateBegin) : new Date();
        this.dateEnd = req != null ? new Date(req.dateEnd) : null;
        this.causeSelected = req != null ? req.causeId : this.causeItems[0].value;
        this.detailMode = req == null ? "I" : "M";
        this.typeSelected = req == null ? "F" : req.typeDay;
        this.currentRequest = req;
        this.isRequestDialogOpen = true;
        $("#" + AssenzeComponent.DIALOG_ID).modal({ backdrop: 'static', keyboard: false });
    }

    closeRequestDetail() {
        $("#" + AssenzeComponent.DIALOG_ID).modal("hide");
        this.isRequestDialogOpen = false;
        this.dateBegin = null;
        this.dateEnd = null;
        this.causeSelected = null;
        this.detailMode = "";
        this.typeSelected = "F";
    }

    openRequestOverlapping(req?: AbsenceRequest) {
        this.usersGroupFilterDialog = false;
        this.applyUsersGroupFilterDialog();
        this.subject = AssenzeComponent.DEFAULT_SUBJECT;
        this.message = "";
        this.currentRequest = req;
        let idRequest = null;
        let dateBegin = null;
        let dateEnd = null;
        if (this.currentRequest) {
            idRequest = this.currentRequest.id;
            dateBegin = this.currentRequest.dateBegin;
            dateEnd = this.currentRequest.dateEnd;
        } else {
            dateBegin = new Date(this.yearSelected, this.monthSelected, 1);
            dateEnd = new Date(this.yearSelected, this.monthSelected + 1, 0);
        }
        let response: DateUserAbsenceResponse;
        this.overlapAbsences = [];
        this.totalOverlapping = 0;
        this.overlapLoading = true;
        this.busyProvider.showBusyIndicator();
        this.assenzeService.findOverlappingAbsences(this.userContext.srmToken, idRequest, dateBegin, dateEnd).subscribe(
            result => {
                response = result;

                let absences = response.dateUserAbsences;
                this.totalOverlapping = response.totalOverlapping;
                let currentRow: RowDateAbsence = null;
                let MODULE: number = 5;
                let rowIndex = 0;
                this.offset = this.getWeekdayOffset(absences[0].date);
                for (let i = 0; i < absences.length; ++i) {

                    if ((i <= MODULE - this.offset && i % (MODULE - this.offset) == 0) || (i > MODULE - this.offset && (i + this.offset) % (MODULE) == 0)) {
                        currentRow = new RowDateAbsence();
                        currentRow.row = rowIndex;
                        currentRow.absences = [];
                        ++rowIndex;
                        this.overlapAbsences.push(currentRow);
                    }
                    this.fillUserColor(absences[i]);
                    currentRow.absences.push(absences[i]);
                }
                let size: number = this.overlapAbsences[this.overlapAbsences.length - 1].absences.length;
                if (MODULE - size > 0) {
                    let step = MODULE - size;
                    while (step > 0) {
                        let empty = new DateUserAbsence();
                        empty.date = null;
                        this.overlapAbsences[this.overlapAbsences.length - 1].absences.push(empty);
                        --step;
                    }
                }
                this.busyProvider.hideBusyIndicator();
                this.overlapLoading = false;
                this.isRequestOverlappingDialogOpen = true;
                $("#" + AssenzeComponent.DIALOG_OVERLAPPING_ID).modal({ backdrop: 'static', keyboard: false });
            },
            error => {
                this.busyProvider.hideBusyIndicator();
                this.handleError(error);
            }
        );
    }

    previousMonth() {
        if (this.monthSelected > 0) {
            this.monthSelected -= 1;
            this.openRequestOverlapping();
        }
        else if (this.monthSelected == 0 && this.yearSelected > this.years[0].value) {
            this.monthSelected = 11;
            this.yearSelected -= 1;
            this.openRequestOverlapping();
        }
    }

    nextMonth() {
        if (this.monthSelected < 11) {
            this.monthSelected += 1;
            this.openRequestOverlapping();
        }
        else if (this.monthSelected == 11 && this.yearSelected < this.years[this.years.length - 1].value) {
            this.monthSelected = 0;
            this.yearSelected += 1;
            this.openRequestOverlapping();
        }
    }

    fillUserColor(absences: DateUserAbsence) {
        for (let i = 0; i < absences.userAbsences.length; ++i) {
            let current = absences.userAbsences[i];
            let color = AppConstants.intToRGB(AppConstants.hashCode(current.username + "." + current.userId));
            current.color = color;
        }
    }

    closeRequestOverlapping() {
        $("#" + AssenzeComponent.DIALOG_OVERLAPPING_ID).modal("hide");
        this.isRequestOverlappingDialogOpen = false;
        this.showMailSection = false;
    }

    openApproveConfirm(req: AbsenceRequest) {
        this.currentRequest = req;
        this.showApproveConfirmPopup = true;
    }

    closeApproveConfirm() {
        this.showApproveConfirmPopup = false;
    }

    openDeleteConfirm(req: AbsenceRequest) {
        this.currentRequest = req;
        this.showDeleteConfirmPopup = true;
    }

    closeDeleteConfirm() {
        this.showDeleteConfirmPopup = false;
    }

    openMailSection() {
        this.showMailSection = true;
    }

    closeMailSection() {
        this.showMailSection = false;
        this.message = "";
        this.subject = AssenzeComponent.DEFAULT_SUBJECT;
    }

    approve() {
        this.messageProvider.clearAll();
        this.busyProvider.showBusyIndicator();
        this.assenzeService.approve(this.userContext.srmToken, this.currentRequest.id).subscribe(
            result => {
                this.busyProvider.hideBusyIndicator();
                this.currentRequest = null;
                this.searchRequests(false, false);
                this.messageProvider.notifyMessage("Richiesta approvata");
                this.assenzeService.fireRefreshEvent();
            },
            error => {
                this.busyProvider.hideBusyIndicator();
                this.currentRequest = null;
                this.handleError(error);
            }
        );
    }

    sendRefuseNotification() {
        this.messageProvider.clearAll();
        this.busyProvider.showBusyIndicator();
        this.assenzeService.refuse(this.userContext.srmToken, this.currentRequest.id, this.subject, this.message).subscribe(
            result => {
                this.busyProvider.hideBusyIndicator();
                this.currentRequest = null;
                this.messageProvider.notifyMessage("Notifica inviata");
            },
            error => {
                this.busyProvider.hideBusyIndicator();
                this.currentRequest = null;
                this.handleError(error);
            }
        );
    }

    deleteRequest() {
        this.messageProvider.clearAll();
        this.busyProvider.showBusyIndicator();
        this.assenzeService.deleteRequest(this.userContext.srmToken, this.currentRequest.id).subscribe(
            result => {
                this.busyProvider.hideBusyIndicator();
                this.currentRequest = null;
                this.searchRequests(false, false);
                this.messageProvider.notifyMessage("Richiesta Eliminata");
                this.assenzeService.fireRefreshEvent();
            },
            error => {
                this.busyProvider.hideBusyIndicator();
                this.currentRequest = null;
                this.handleError(error);
            }
        );
    }

    storeRequest() {
        this.messageProvider.clearAll();
        if (this.detailMode == "I") {
            this.busyProvider.showBusyIndicator();
            this.assenzeService.insertRequest(this.userContext.srmToken, this.dateBegin, this.dateEnd, this.causeSelected, this.typeSelected).
                subscribe(
                    result => {
                        this.busyProvider.hideBusyIndicator();
                        this.closeRequestDetail();
                        this.messageProvider.notifyMessage("Richiesta Inviata");
                        this.searchRequests(false, false);
                        this.assenzeService.fireRefreshEvent();
                    },
                    error => {
                        this.busyProvider.hideBusyIndicator();
                        this.closeRequestDetail();
                        this.handleError(error);
                    }
                );
        }
        else if (this.detailMode == "M") {
            this.busyProvider.showBusyIndicator();
            this.assenzeService.updateRequest(this.userContext.srmToken, this.currentRequest.id, this.dateBegin, this.dateEnd, this.causeSelected, this.typeSelected).
                subscribe(
                    result => {
                        this.busyProvider.hideBusyIndicator();
                        this.closeRequestDetail();
                        this.messageProvider.notifyMessage("Richiesta Modificata");
                        this.currentRequest = null;
                        this.searchRequests(false, false);
                        this.assenzeService.fireRefreshEvent();
                    },
                    error => {
                        this.busyProvider.hideBusyIndicator();
                        this.closeRequestDetail();
                        this.currentRequest = null;
                        this.handleError(error);
                    }
                );
        }
    }

    sort(field: string, directionAsc?: boolean) {
        let formatDate: string = "yyyyMMdd";
        if (field == this.sortField) {
            this.sortAsc = (directionAsc != null && typeof (directionAsc) != 'undefined') ? directionAsc : !this.sortAsc;
        } else {
            this.sortField = field;
        }

        this.requests = this.requests.sort((r1, r2) => {
            if (this.sortField == "dateRequest") {
                let d1 = this.datePipe.transform(r1.createdAt, formatDate);
                let d2 = this.datePipe.transform(r2.createdAt, formatDate);
                if (d1 == d2) {
                    return 0;
                }
                return this.sortAsc ? (d1 > d2 ? 1 : -1) : (d1 > d2 ? -1 : 1);
            }
            if (this.sortField == "dateFrom") {
                let d1 = this.datePipe.transform(r1.dateBegin, formatDate);
                let d2 = this.datePipe.transform(r2.dateBegin, formatDate);
                if (d1 == d2) {
                    d1 = this.datePipe.transform(r1.dateEnd, formatDate);
                    d2 = this.datePipe.transform(r2.dateEnd, formatDate);
                    return d1 > d2 ? 1 : -1;
                }
                return this.sortAsc ? (d1 > d2 ? 1 : -1) : (d1 > d2 ? -1 : 1);
            }
            if (this.sortField == "user") {
                if (r1.userId == r2.userId) {
                    let d1 = this.datePipe.transform(r1.createdAt, formatDate);
                    let d2 = this.datePipe.transform(r2.createdAt, formatDate);
                    if (d1 == d2) {
                        return 0;
                    }
                    return d1 > d2 ? -1 : 1;
                } else {
                    return this.sortAsc ? (r1.fullname > r2.fullname ? 1 : -1) : (r1.fullname > r2.fullname ? -1 : 1);
                }
            }
            return 0;
        });

    }

    reload() {
        this.searchRequests(false, true);
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;
    }

    applyFilter() {
        this.searchRequests(true, true);
    }

    requestTypesFilterChange() {
        if ((this.requestTypeSelected == '' || this.requestTypeSelected == 'A') && !this.requestFromDate) {
            this.requestFromDate = new Date();
            this.requestFromDate.setMonth(this.requestFromDate.getMonth() - 6);
        } else if (this.requestTypeSelected == 'D') {
            var date = new Date();
            date.setMonth(date.getMonth() - 6);
            if (this.requestFromDate.getDate() == date.getDate()) {
                this.requestFromDate = null;
            }
        }
    }

    display(section: string) {
        this.displayAbsences = '';
        this.displayRequests = '';
        this.displayReport = '';
        if (section === 'requests') {
            this.displayRequests = 'active';
        } else if (section === 'absences') {
            this.displayAbsences = 'active';
        } else if (section === 'report') {
            this.displayReport = 'active';
            if (this.holidayReport.rows === null) {
                this.holidayReport.loadHolidayReport();
            }
        }
    }

    shortcutHandler(event) {
        if (event.keyCode == 27) { // ESC
            if (this.isRequestDialogOpen) {
                this.closeRequestDetail();
            } else if (this.isRequestOverlappingDialogOpen) {
                this.closeRequestOverlapping();
            }
        }
    }

    getGruppo(id: number): string | null {
        const gruppo = this.gruppi.find(userGroup => userGroup.value === id);
        if (gruppo) {
            return gruppo.label;
        }
        return null;
    }

    isUserVisible(userId: number): boolean {
        return !this.usersGroupFilterDialog || this.utentiVisibiliDialog.some(item => item.value === userId);
    }

    filterUtentiGruppi(event) {
        this.utentiVisibili = [];
        if (event == 0) {
            this.utentiVisibili = [...this.managedUsers];
        } else {
            const usernames = this.userInfo.managedUsersMap[this.getGruppo(event)];

            if (Array.isArray(usernames)) {
                for (let username of usernames) {
                    const user = this.filterUsernames.find(u =>
                        u.label.toLowerCase().includes(username.toLowerCase())
                    );
                    if (user) {
                        let item = this.filterUsers.find(u => u.value == user.value)
                        this.utentiVisibili.push({ label: item.label, value: item.value });
                    }
                }
            }
        }
        if (this.currentUserId && !this.utentiVisibili.some(u => u.value === this.currentUserId)) {
            const currentUserItem = this.filterUsers.find(u => u.value === this.currentUserId);
            if (currentUserItem) {
                this.utentiVisibili.unshift({ label: currentUserItem.label, value: currentUserItem.value });
            }
        }
    }

    filterUtentiGruppiDialog(event) {

        this.utentiVisibiliDialog = [];
        if (event == 0) {
            this.utentiVisibiliDialog = [...this.managedUsers];
        } else {
            const usernames = this.userInfo.managedUsersMap[this.getGruppo(event)];

            if (Array.isArray(usernames)) {
                for (let username of usernames) {
                    const user = this.filterUsernames.find(u =>
                        u.label.toLowerCase().includes(username.toLowerCase())
                    );
                    if (user) {
                        let item = this.filterUsers.find(u => u.value == user.value)
                        this.utentiVisibiliDialog.push({ label: item.label, value: item.value });
                    }
                }
            }
        }
        if (this.currentUserId && !this.utentiVisibiliDialog.some(u => u.value === this.currentUserId)) {
            const currentUserItem = this.filterUsers.find(u => u.value === this.currentUserId);
            if (currentUserItem) {
                this.utentiVisibiliDialog.unshift({ label: currentUserItem.label, value: currentUserItem.value });
            }
        }
    }

    getGruppoUser(utente: User): string | null {
        if (!this.userInfo || !this.userInfo.managedUsersMap) return null;

        const managedUsersMap = this.userInfo.managedUsersMap;

        for (const key in managedUsersMap) {
            if (Object.prototype.hasOwnProperty.call(managedUsersMap, key)) {
                const value = managedUsersMap[key];
                if (Array.isArray(value) && value.some(v => v.toLowerCase() === utente.username.toLowerCase())) {
                    return key;
                }
            }
        }
        return null;
    }

    applyUsersGroupFilter() {
        this.utentiVisibili = [];
        this.usersGroupFilter = !this.usersGroupFilter;

        if (this.usersGroupFilter) {
            if (this.gruppi.length == 2) {
                this.filterUtentiGruppi(1);
            } else {
                this.filterUtentiGruppi(0);
            }
        }
    }

    applyUsersGroupFilterDialog() {
        this.utentiVisibiliDialog = [];
        this.usersGroupFilterDialog = !this.usersGroupFilterDialog;

        if (this.usersGroupFilterDialog) {
            if (this.gruppi.length == 2) {
                this.filterUtentiGruppiDialog(1);
            } else {
                this.filterUtentiGruppiDialog(0);
            }
        }
    }

    getWeekdayOffset(date: Date): number {
        const d = new Date(date);
        const jsDay = d.getDay();
        return jsDay === 0 ? 6 : jsDay - 1;
    }


}

class RowDateAbsence {
    row: number;
    absences: DateUserAbsence[] = [];
}



// WEBPACK FOOTER //
// ./src/app/assenze/assenze.component.ts